/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KpiI18nDto } from './kpi-i18n-dto';


export interface UpdateKpiDto { 
    /**
     * Search and categorization tags for this KPI.
     */
    tags?: Array<string>;
    /**
     * Localized KPI copy keyed by locale. English (en) and German (de) are required; additional locale keys are allowed. Replaces the whole stored map: a locale left out is removed, so send every language to keep, not only the changed ones.
     */
    i18n?: KpiI18nDto;
    /**
     * Archive the KPI, or restore an archived one to draft. Publish via /published-version.
     */
    status?: UpdateKpiDto.StatusEnum;
}
export namespace UpdateKpiDto {
    export const StatusEnum = {
        Archived: 'archived',
        Draft: 'draft'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


